import React from 'react';
import _ from 'lodash';
import csvParse from 'csv-parse/lib/sync';
import { Route } from 'react-router-dom';
import HeaderThin from 'app/components/layout/HeaderThin';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as organisationsActions from 'app/ducks/organisations/actions';
import * as competitionsActions from 'app/ducks/competitions/actions';
import * as fixtureMatchesActions from 'app/ducks/fixtureMatches/actions';
import * as fixtureMatchImportsActions from 'app/ducks/fixtureMatchImports/actions';

import * as organisationSelectors from 'app/ducks/organisations/selectors';
import * as competitionSelectors from 'app/ducks/competitions/selectors';
import * as fixtureMatchSelectors from 'app/ducks/fixtureMatches/selectors';
import * as fixtureMatchImportSelectors from 'app/ducks/fixtureMatchImports/selectors';

import ChooseImportType from './components/ChooseImportType';
import CsvRunFixtureCreate from './components/CsvRunFixtureCreate';
import CsvRunPeopleCreate from './components/CsvRunPeopleCreate';

function selector(state): any {
  return {
    organisations: organisationSelectors.getOrganisations(state),
    competitions: competitionSelectors.getCompetitions(state),
    fixtureMatches: fixtureMatchSelectors.getFixtureMatches(state),
    fixtureMatchImports: fixtureMatchImportSelectors.getFixtureMatchImports(
      state,
    ),
  };
}

const actionCreators = _.merge(
  organisationsActions,
  competitionsActions,
  fixtureMatchesActions,
  fixtureMatchImportsActions,
);

interface ICsvRunCreateProps {
  appReady: boolean;
  actions: any;
  organisations: any;
  competitions: any;
  fixtureMatches: any;
  fixtureMatchImports: any;
  match: any;
  errors: any;
}

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class CsvRunCreate extends React.Component<ICsvRunCreateProps> {
  static defaultProps: ICsvRunCreateProps = {
    appReady: false,
    actions: undefined,
    organisations: {},
    competitions: {},
    fixtureMatches: {},
    fixtureMatchImports: {},
    match: undefined,
    errors: undefined,
  };

  componentDidMount = (): void => {
    this.props.actions.getAllCompetitions();
  };

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <Route
              exact
              path="/connections/:connectionId/run"
              render={(): React.ReactNode => (
                <ChooseImportType
                  {...this.props}
                />
              )}
            />

            <Route
              exact
              path={[
                '/connections/:connectionId/run/csv/fixture',
                '/connections/:connectionId/run/csv/fixture/map',
              ]}
              render={(): React.ReactNode => (
                <CsvRunFixtureCreate {...this.props} {...this.state} />
              )}
            />

            <Route
              exact
              path={[
                '/connections/:connectionId/run/csv/team-contact',
                '/connections/:connectionId/run/csv/team-contact/map',
              ]}
              render={(): React.ReactNode => (
                <CsvRunPeopleCreate {...this.props} />
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}
